/**
 * Created by admin on 2018/5/8.
 */
import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Input, Modal, Table } from 'antd';
import './CleaningManage.less';
import { Btn, OperateSpan } from '../../components/Widgets';
import IconTip from '../../components/IconTip';
import _ from 'lodash';

const GRADE_TAB = '1';
const ITEM_TAB = '2';

class CleaingManage extends PureComponent {

  render() {
    const {  dispatch, intl, account, activeKey} = this.props;
    const {cleaningModal,cleaningPersonObj,cleaningPersons} = account;
    let backToServiceManageTitle='';
    if (activeKey === GRADE_TAB) {
      backToServiceManageTitle = intl.formatMessage({ id: 'service_back_to_service_manage_title' });
    } else if (activeKey === ITEM_TAB) {
      backToServiceManageTitle = intl.formatMessage({ id: 'service_back_to_service_manage_title' });
    }
    return (
      <div className="cleaning-Management">
        <div className="cleaning-list-head">
          <div className="prefix-title">
            <FormattedMessage id="cleaning_manage_list" />
          </div>
          <div>
            <Button
              type="primary"
              icon="plus"
              className="new-btn"
              onClick={() => this.showModal({})}
            >
              <FormattedMessage id="service_add_cleaning_manage_title" />
            </Button>
            <Button
              className="back-service-manage"
              onClick={() => {
                this.props.onClick();
              }}
            >
              {backToServiceManageTitle}
            </Button>
          </div>
        </div>
        <Table
          columns={[
            {
              title: intl.formatMessage({ id: 'cleaning_manage_name' }),
              dataIndex: 'name',
              key: 'name'
            },
            {
              title: intl.formatMessage({ id: 'cleaning_manage_phone' }),
              dataIndex: 'phone',
              key: 'phone'
            },
            {
              title: intl.formatMessage({ id: 'cleaning_manage_email' }),
              dataIndex: 'email',
              key: 'email'
            },
            {
              title: intl.formatMessage({ id: 'cleaning_manage_operate' }),
              key: 'action',
              render: (text, record) => {
                return (
                  <div className="cleaning-operate">

                    <OperateSpan onClick={this.showCleaningEdit.bind(this, record)}>
                      <IconTip
                        title={intl.formatMessage({ id: 'role_manage_edit' })}
                        type="guanliyuan"
                      />
                    </OperateSpan>

                      <OperateSpan
                        onClick={this.deleteCleaning.bind(this, record.id)}
                      >
                        <IconTip
                          title={intl.formatMessage({
                            id: 'role_manage_delete'
                          })}
                          type="shanchu"
                        />
                      </OperateSpan>
                  </div>
                );
              }
            }
          ]}
          dataSource={cleaningPersons}
          rowKey={record => record.id}
          pagination={
            cleaningPersons.length > 10
              ? {
                  total: cleaningPersons.length,
                  pageSize: 10
                }
              : false
          }
        />

        <Modal
          wrapClassName="service-manage-wrapper modal-close-header"
          visible={cleaningModal}
          title={intl.formatMessage({id: 'meeting_services_info_value8'})}
          onCancel={() => this.closeModal()}
          footer={
            <div className="service-manage-footer">
              <Btn onClick={() => this.closeModal()}>
                {intl.formatMessage({ id: 'dialog_btn_cancel' })}
              </Btn>
              <Btn primary onClick={() => this.submit()}>
                {intl.formatMessage({ id: 'dialog_btn_ok' })}
              </Btn>
            </div>
          }
        >
          <div className="service-manage-modal">
            <div className="manage-row">
              <span className="prefix-title">
              <i className="iconfont icon-bitian" />
              {intl.formatMessage({ id: 'cleaning_manage_name' })} :
              </span>
              <Input
                maxLength="10"
                value={cleaningPersonObj.name || ''}
                onChange={e => {
                  cleaningPersonObj.name = e.target.value;
                  dispatch({ type: 'account/update', payload: cleaningPersonObj });
                }}
              />
            </div>

            <div className="manage-row">
              <span className="prefix-title">
              <i className="iconfont icon-bitian" />
                {intl.formatMessage({ id: 'cleaning_manage_phone' })} :
              </span>
              <Input
                maxLength={'30'}
                value={cleaningPersonObj.phone || ''}
                onChange={e => {
                  cleaningPersonObj.phone = e.target.value;
                  dispatch({ type: 'account/update', payload: cleaningPersonObj });
                }}
              />
            </div>

            <div className="manage-row">
              <span className="prefix-title">
                {intl.formatMessage({ id: 'cleaning_manage_email' })} :
              </span>
              <Input
                maxLength={'30'}
                value={cleaningPersonObj.email || ''}
                onChange={e => {
                  cleaningPersonObj.email = e.target.value;
                  dispatch({ type: 'account/update', payload: cleaningPersonObj });
                }}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }


  clearState = () => {
    
  };
  showModal = svcEditObj => {
    this.props.dispatch({
      type: 'account/update',
      payload: {
        cleaningModal: true,
        cleaningPersonObj: _.cloneDeep(svcEditObj)
      }
    });
  };

  closeModal = () => {
    this.props.dispatch({
      type: 'account/update',
      payload: { cleaningModal: false }
    });
  };
  submit = () => {
    const { dispatch } = this.props;
    dispatch({ type: 'account/setCleaningPerson' });
  };
  showCleaningEdit = editCleaning => {
    this.props.dispatch({
      type: 'account/update',
      payload: {
        cleaningModal: true,
        cleaningPersonObj: _.cloneDeep(editCleaning)
      }
    });
  };
  deleteCleaning = id => {
    Modal.confirm({
      content: this.props.intl.formatMessage({
        id: 'role_manage_delete_confirm'
      }),
      onOk: () => {
        const promise = new Promise((resolve, reject) => {
          this.props.dispatch({ type: 'account/deleteCleaning', id, resolve, reject });
        });
        promise.then(
          () => {
            const { id: editRoleId } = this.state;
            if (editRoleId === id) {
              this.clearState();
            }
          },
          msg => {
            Modal.error({ content: msg });
          }
        );
      }
    });
  };
  
}

const mapStateToProps = state => {
    return state;
};

export default connect(mapStateToProps)(injectIntl(CleaingManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/CleaningManage.js